import React, { useState } from 'react'
import { Button } from 'antd'
import { useTraversal, Textarea } from '@guillotinaweb/react-gmi'

import { I18NField } from './i18nfield'
import { setLangs } from '../consts'

const seoField = 'api.behaviors.submenu.ISubmenuBehavior'
const example = `[
  {"selector": "link", "value": "/", "label": "Vinissimus" }
]`

export function SubmenuTab() {
  const Ctx = useTraversal()
  const submenu = Ctx.state.context[seoField].submenu || {}
  const [saving, setSaving] = useState(false)
  const [menu, setMenu] = useState(submenu || setLangs(''))
  const [jsonError, setJsonError] = useState(false)

  const h1 =
    typeof Ctx.state.context.title === 'string'
      ? Ctx.state.context.title
      : Ctx.state.context['@name']

  async function save() {
    if (jsonError) {
      alert('invalid json')
      return
    }
    setSaving(true)
    const flashOk = ['SEO fields saved', 'success']
    const flashKo = ['Error saving the SEO fields', 'danger']
    const { status } = await Ctx.client.patch(Ctx.path, {
      [seoField]: { submenu: menu },
    })
    Ctx.flash(...(status === 204 ? flashOk : flashKo))
    setSaving(false)
  }

  return (
    <>
      <div
        style={{
          backgroundColor: 'white',
          display: 'flex',
          padding: 10,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h1 className="title is-size-4 is-primary">{h1}</h1>
        <Button type="primary" disabled={saving} onClick={save}>
          {saving ? 'Saving...' : 'Save submenu'}
        </Button>
      </div>
      <I18NField Widget={() => null}>
        {(lang) => (
          <div style={{ marginTop: 20 }}>
            <p>Lang {lang}</p>

            <Textarea
              name={lang}
              value={
                typeof menu[lang] === 'object'
                  ? JSON.stringify(menu[lang])
                  : menu[lang]
              }
              onChange={(v) => {
                let err = null
                let val = undefined
                try {
                  val = JSON.parse(v)
                  setJsonError(false)
                } catch (e) {
                  err = 'invalid'
                  val = v
                  setJsonError(true)
                }
                setMenu((o) => ({ ...o, [lang]: val }))
              }}
              rows={15}
              style={{
                fontFamily: 'Menlo, Consolas, Courier New',
                fontSize: '12px',
              }}
              error={jsonError}
            />
          </div>
        )}
      </I18NField>
      <code style={{ color: 'grey' }}>{example}</code>
    </>
  )
}
